// extracted by mini-css-extract-plugin
export var parcelRow = "_tm-0";